import React, { useEffect, useRef } from 'react';

const UtterancesComments = ({ postId }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    if (containerRef.current && containerRef.current.children.length === 0) {
      const script = document.createElement('script');
      script.src = 'https://utteranc.es/client.js';
      script.setAttribute('repo', 'Wais000/cyberscurity-portfolio');
      script.setAttribute('issue-term', 'pathname');
      script.setAttribute('theme', 'github-dark');
      script.setAttribute('crossorigin', 'anonymous');
      script.async = true;
      containerRef.current.appendChild(script);
    }
  }, []);

  return (
    <div className="utterances-wrapper">
      <div ref={containerRef} className="mt-8 min-h-[200px]" />
    </div>
  );
};

export default UtterancesComments;